/* Veymonta sticky add-to-cart (2026-10-27): shows when the main Add to cart button scrolls out of view; clicking it presses the main button. */
(function(){
  function init(){
    var bar=document.querySelector('.vey-sticky'); if(!bar) return;
    var main=null;
    document.querySelectorAll('button[type="submit"], button[name="add"]').forEach(function(b){ if(!main && /add to cart/i.test(b.textContent)) main=b; });
    if(!main) return;
    new IntersectionObserver(function(e){ bar.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top<0); }).observe(main);
    bar.querySelector('button').addEventListener('click',function(){ main.click(); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

/* vey-autoloop */
(function(){
  function run(){
    document.querySelectorAll('.product-media-container--video deferred-media').forEach(function(d){
      if(d.dataset.veyLoop) return;
      var t=d.querySelector('template'); if(!t) return;
      var v=t.content.querySelector('video'); if(!v) return;
      v=v.cloneNode(true);
      v.muted=true; v.loop=true; v.autoplay=true; v.playsInline=true; v.removeAttribute('controls');
      v.setAttribute('muted',''); v.setAttribute('loop',''); v.setAttribute('playsinline',''); v.setAttribute('preload','auto');
      v.className='vey-autoloop';
      d.dataset.veyLoop='1';
      d.querySelectorAll('.deferred-media__poster-button').forEach(function(b){b.style.display='none';});
      d.appendChild(v);
      var p=v.play(); if(p&&p.catch) p.catch(function(){});
    });
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  setTimeout(run,1500);
})();
/* /vey-autoloop */
